/**
 * Ops login-as (read-only vendor impersonation). Captured from `#loginAs=<token>`
 * on load; used as the API bearer instead of Auth0. See payup-api ops-login-as.
 */

let loginAsToken: string | null = null;

export const securityOptions = {
  getLoginAsToken: () => loginAsToken,
  setLoginAsToken: (token: string | null) => {
    loginAsToken = token;
  },
  hasOpsGrant: () => !!loginAsToken,
};

/**
 * Read an ops login-as token from `#loginAs=<token>` and strip it from the URL
 * so it is not re-sent on navigation / shared via referrer.
 */
export const setLoginAsTokenFromLocation = () => {
  if (typeof window === 'undefined') return;
  try {
    const hash = window.location.hash || '';
    const match = hash.match(/[#&]loginAs=([^&]+)/);
    if (match?.[1]) {
      loginAsToken = decodeURIComponent(match[1]);
      const cleaned = hash
        .replace(/([#&])loginAs=[^&]+/, '$1')
        .replace(/[#&]$/, '')
        .replace(/^#&/, '#');
      const nextHash = cleaned === '#' || cleaned === '' ? '' : cleaned;
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}${nextHash}`
      );
    }
  } catch {
    // Non-browser — login-as mode stays off.
  }
};
